// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.x-table-banded {

}

table.x-table-banded thead tr {
    
}

table.x-table-banded thead tr th {
    font-weight: bold;
    padding-left: 2px;
}

table.x-table-banded tbody tr td {
    padding: 2px;
}

table.x-table-banded tbody tr:nth-child(odd) {
    background-color: #f2f2f2;;    
}

table.x-table-banded tbody tr:nth-child(even) {
    background-color: #ffffff;;
}

table.x-table-banded tbody tr:hover {
    background-color: #d8d8d8;
}

.x-hover-blue:hover {
    color: blue;
}

.x-hover-red:hover {
    color: red;
}

.x-new-query-btn {
    font-weight: bold;
    padding: 0px 5px;
    font-size: 125%;
}

.x-new-query-btn img {
    width: 32px;
    height: 32px;
}

.x-text-dark-blue {
    color: #12355b;
    text-transform: capitalize;
    font-weight: bold;
}

.x-text-light-blue {
    color: #2da9da;
    text-transform: capitalize;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/XSifterAppPage.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;AACrB","sourcesContent":["table.x-table-banded {\r\n\r\n}\r\n\r\ntable.x-table-banded thead tr {\r\n    \r\n}\r\n\r\ntable.x-table-banded thead tr th {\r\n    font-weight: bold;\r\n    padding-left: 2px;\r\n}\r\n\r\ntable.x-table-banded tbody tr td {\r\n    padding: 2px;\r\n}\r\n\r\ntable.x-table-banded tbody tr:nth-child(odd) {\r\n    background-color: #f2f2f2;;    \r\n}\r\n\r\ntable.x-table-banded tbody tr:nth-child(even) {\r\n    background-color: #ffffff;;\r\n}\r\n\r\ntable.x-table-banded tbody tr:hover {\r\n    background-color: #d8d8d8;\r\n}\r\n\r\n.x-hover-blue:hover {\r\n    color: blue;\r\n}\r\n\r\n.x-hover-red:hover {\r\n    color: red;\r\n}\r\n\r\n.x-new-query-btn {\r\n    font-weight: bold;\r\n    padding: 0px 5px;\r\n    font-size: 125%;\r\n}\r\n\r\n.x-new-query-btn img {\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.x-text-dark-blue {\r\n    color: #12355b;\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n}\r\n\r\n.x-text-light-blue {\r\n    color: #2da9da;\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
